import { render, staticRenderFns } from "./SubpanelTable.vue?vue&type=template&id=19f71b4f&scoped=true"
import script from "./SubpanelTable.vue?vue&type=script&lang=js"
export * from "./SubpanelTable.vue?vue&type=script&lang=js"
import style0 from "./SubpanelTable.vue?vue&type=style&index=0&id=19f71b4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f71b4f",
  null
  
)

export default component.exports